module.exports = __webpack_public_path__ + "static/media/Cowgirl.a2101dc6.jpg";